<template>

    <dialogs-base :show.sync="dialog" max-width="20%">

        <template v-slot:activator="{ on, attrs }">  
          <v-text-field
            v-model="model"
            :label="label"
            readonly
            v-bind="attrs"
            v-on="on"
            :error-messages="errorMessages"
            :hide-details="errorMessages ? false : true"
            :dense="dense"
          >
            <template v-slot:append>
                <v-icon small>mdi-clock-time-four-outline</v-icon>
            </template>
        </v-text-field>
        </template>

        <template v-slot:body>

            <v-time-picker v-model="model" full-width format="24hr">
                <v-spacer></v-spacer>
                <ButtonsText label="Cancelar" color="error" @click="dialog = false" />
                <ButtonsText label="Confirmar" @click="closeDialog" />
            </v-time-picker>

        </template>
    </dialogs-base>

</template>

<script setup>
import { defineProps, defineEmits, computed, ref } from 'vue'

const props = defineProps({
    value: { type: String },
    label: { type: String, required: false },
    errorMessages:  { type: Array, required: false },
    dense: { type: Boolean, default: false },
})

const emit = defineEmits(['input'])
const time = ref('')

const model = computed({
    get() {
        return props.value
    },
    set(val) {
        //Valor que será utilizado caso o usuário confirme
        time.value = val
    }
})

const dialog = ref(false)

function closeDialog() {
    dialog.value = false
    emit('input', time.value)
}

</script>